// Third-party libraries
import React, { Component, Fragment } from "react";

import { scaleLinear } from "d3-scale";
import { median, max, histogram } from "d3-array";
import { axisBottom } from "d3-axis";
import { select, selectAll } from "d3-selection";
import {
  annotation,
  annotationLabel,
  annotationCalloutElbow
} from "d3-svg-annotation";

// Project dependancies
import variables from "../sass/_variables.scss";
import { debounce } from "../utilities";

class Histogram extends Component {
  constructor(props) {
    super(props);
    this.histogram = React.createRef();
  }

  componentDidMount() {
    const delayedMakeChart = debounce(() => {
      this.makeChart(
        this.props.players,
        this.histogram.current.getBoundingClientRect().width,
        this.histogram.current.getBoundingClientRect().height,
        this.props.visitor
      );
    }, 100);

    window.addEventListener("resize", delayedMakeChart);

    this.makeChart(
      this.props.players,
      this.histogram.current.getBoundingClientRect().width,
      this.histogram.current.getBoundingClientRect().height,
      this.props.visitor
    );
  }

  makeChart = (players, outerWidth, outerHeight, visitor) => {
    selectAll("svg.chart > *").remove();
    const scores = players.map(player => player.netpoints);
    const highScore = max(scores);
    const leader = players.find(player => (player.netpoints = highScore));
    const binCount = 50;
    // width = binCount + Math.floor((width - binCount - 60) / 50) * 50 + 61; // Helps space out the bars

    var svg = select("svg.histogram"),
      margin = { top: 10, right: 30, bottom: 30, left: 10 },
      width = outerWidth - margin.left - margin.right,
      height = outerHeight - margin.top - margin.bottom,
      g = svg
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    var x = scaleLinear()
      .rangeRound([0, width])
      .domain([0, max(scores)]);

    var medianScore = median(scores);
    var bins = histogram()
      .domain(x.domain())
      .thresholds(x.ticks(binCount))(scores);

    var y = scaleLinear()
      .domain([
        0,
        max(bins, function(d) {
          return d.length;
        })
      ])
      .range([height, 0]);

    var bar = g
      .selectAll(".bar")
      .data(bins)
      .enter()
      .append("g")
      .attr("class", d => {
        if (medianScore >= d.x0 && medianScore < d.x1) {
          return "bar bar--secondary";
        } else {
          return "bar";
        }
      })
      .attr("transform", function(d) {
        return "translate(" + x(d.x0) + "," + y(d.length) + ")";
      });
    bar
      .append("rect")
      .attr("x", 1)
      .attr("width", x(bins[0].x1) - x(bins[0].x0) - 2)
      .attr("height", function(d) {
        return height - y(d.length);
      });

    g.append("g")
      .attr("class", "axis axis--x")
      .attr("transform", "translate(0," + height + ")")
      .call(axisBottom(x).ticks(5));

    if (visitor.netpoints) {
      svg
        .append("line")
        .attr("x1", x(visitor.netpoints) + margin.left)
        .attr("y1", margin.top)
        .attr("x2", x(visitor.netpoints) + margin.left)
        .attr("y2", height + margin.top)
        .style("stroke-width", 2)
        .style("stroke", variables.colorPrimary)
        .style("stroke-dasharray", "5,2");
    }
    const annotations = [
      {
        note: {
          label: leader.screen_name,
          align: "right"
        },
        connector: {
          end: "dot", // 'dot' also available
          type: annotationCalloutElbow,
          endScale: 0.5
        },
        x: x(leader.netpoints),
        y: height + margin.top,
        dy: -20,
        dx: -20,
        color: variables.colorRule
      }
    ];
    const makeAnnotations = annotation()
      .type(annotationLabel)
      .notePadding(0)
      .annotations(annotations);

    svg
      .append("g")
      .attr("class", "annotation-group histogram__leader")
      .call(makeAnnotations);

    select(".histogram__leader .annotation-note-label").on("click", () => {
      window.location.href = `/${leader.handle}`;
    });
  };

  render() {
    return (
      <Fragment>
        <h5>Player distribution</h5>
        <aside className="leaders-histogram">
          <div className="legend">
            <div className="legend-item legend-item--secondary">Median</div>
            {this.props.visitor && this.props.visitor.netpoints > 0 && (
              <div className="legend-item legend-item--primary legend-item--line">
                You
              </div>
            )}
          </div>
          <svg
            className="chart histogram"
            ref={this.histogram}
            width="100%"
            height="150"
          />
        </aside>
      </Fragment>
    );
  }
}

export default Histogram;
